import script from "./CustomReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomReports.vue?vue&type=script&setup=true&lang=ts"

import "./CustomReports.vue?vue&type=style&index=0&id=70422e8c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70422e8c"]])

export default __exports__